const storesPath = '/product-page/';
const bookingsPath = '/bookings-checkout/';
const eventsPath = '/event-details/';
const UNIVERSAL_DELIMITER = '?d=';
const UNIVERSAL_REGEX = /^https:\/\/www.wix.app/;
const getWebUrlFromUniversalUrl = (url) => url.split(UNIVERSAL_DELIMITER)[1];
const getVerticalRelativePath = (webUrl) => {
    const position = Math.max(webUrl.indexOf(storesPath), webUrl.indexOf(bookingsPath), webUrl.indexOf(eventsPath));
    return webUrl.slice(position);
};
const removeLastSlashFromUrl = (url) => url.replace(/\/$/, '');
const replaceWebUrlInsideUniversalUrl = (universalUrl, webUrl) => {
    const base = universalUrl.split(UNIVERSAL_DELIMITER)[0];
    return `${base}${UNIVERSAL_DELIMITER}${webUrl}`;
};
export const changeBaseUrl = (url, baseUrl) => {
    const isUniversalUrl = url.match(UNIVERSAL_REGEX);
    const oldWebUrl = isUniversalUrl ? getWebUrlFromUniversalUrl(url) : url;
    const path = getVerticalRelativePath(oldWebUrl);
    const webUrl = removeLastSlashFromUrl(baseUrl) + path;
    return isUniversalUrl ? replaceWebUrlInsideUniversalUrl(url, webUrl) : webUrl;
};
//# sourceMappingURL=changeBaseUrl.js.map